import { createStandaloneToast } from 'src/components/ui';

const { ToastContainer, toast } = createStandaloneToast();

const TOAST_CONTAINER_STYLE = { zIndex: 99999 };

const toastSuccess = (message: string) => {
	toast({
		description: message,
		status: 'success',
		duration: 5000,
		isClosable: true,
		position: 'top-right',
		containerStyle: TOAST_CONTAINER_STYLE,
	});
};

const toastError = (error: any, list?: Array<string>) => {
	const whiteList = [401, 403, 500, ...(list ? list : [])];
	if (!error.response) {
		console.log('Toast error, error response undefined', error);
		return;
	}
	const { code, message } = error.response.data;

	if (!whiteList.includes(code)) {
		toast({
			description: message,
			status: 'error',
			duration: 5000,
			isClosable: true,
			position: 'top-right',
			containerStyle: TOAST_CONTAINER_STYLE,
		});
	}
};

const toastErrorGlobal = (error: any) => {
	const { message } = error.data;
	toast({
		description: message,
		status: 'error',
		duration: 5000,
		isClosable: true,
		position: 'top-right',
		containerStyle: TOAST_CONTAINER_STYLE,
	});
};

const customToast = (
	message: string,
	status?: 'info' | 'warning' | 'success' | 'error' | 'loading',
) => {
	toast({
		description: message,
		status: status ?? 'info',
		duration: 5000,
		isClosable: true,
		position: 'top-right',
		containerStyle: TOAST_CONTAINER_STYLE,
	});
};

export {
	ToastContainer,
	toastError,
	toastSuccess,
	toastErrorGlobal,
	customToast,
};
